import { App, Button, Dropdown, Row, Table, Tag } from "antd";
import { useFiltersContext } from "../../../contexts/filtersContext";
import ActionButton from "../../masterComponents/actionButton";
import Filters from "../../masterComponents/Filters";
import { ContainerWrapper } from "../../../app/app.style";
import { StyledButtonContainer } from "./rules.style";
import { LuClipboardPlus } from "react-icons/lu";
import { TbTableDown } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useFetchData as usePagination } from "../../../hooks/useFetch/pagination";
import { onSorter } from "../../../utils";
import { useFetchData } from "../../../hooks/useFetch/post";
import { useCommonPropertiesContext } from "../../../contexts/commonPropertiesContext";
import Icon from "../../masterComponents/Icon";
import { ALL_BATCHES, DEFAULT_OPEN_KEYS_RULES } from "../../../entities/entities";
import { FaChevronDown } from "react-icons/fa";
import { useFilterStructure } from "../../../hooks/useFilterStructure/useFilterStructure";
import { buildFilterStructure } from "../../../utils/filtersStructureHelpers";
import { PHRASES_DICTIONARY } from "../../../entities/phrasesDictionary";

const columns = [
  {
    title: "Rule Name",
    dataIndex: "ruleName",
  },
  {
    title: "Text",
    dataIndex: "text",
  },
  {
    title: "Target Characteristics",
    dataIndex: "targetCharacteristics",
  },
];

const Rules = () => {
  const {
    appliedFilters,
    setAppliedFilters,
    ignoredFilter,
    setIgnoredFilter,
    updateFilter,
  } = useFiltersContext();
  const {
    availableFilters: availableRulesFilters,
    activeFilters,
    classNameFilterValues,
  } = useFilterStructure("rules");

  const { currentBatch } = useCommonPropertiesContext();
  const [selectedBatch, setSelectedBatch] = useState(currentBatch);

  const [selectedCheckbox, setSelectedCheckbox] = useState(null);
  
  const [rulesDataTable, setRulesDataTable] = useState([]);

  const appliedRef = useRef(null);

  const navigate = useNavigate();

  const { message: messageApi } = App.useApp();

  const [fetchRulesData,
    {
      isLoading: isLoadingRulesData,
      data: rulesData,
      page,
      totalRows,
      error: rulesDataError,
      loadMore,
      clearError: clearRulesDataError,
    },
  ] = usePagination({
    query: "/rules",
    selectData: (data) => data.items,
    selectPageInfo: (data) => data.page_info,
  });

  useEffect(() => {
    if (rulesDataError) {
      messageApi.error(rulesDataError.message);
      clearRulesDataError();
    }
  }, [rulesDataError, messageApi]);

  const [fetchUploadReport,
    {
      isLoading: isLoadingReport,
      data: uploadingReportData,
      error: uploadingReportError,
      clearError: clearUploadingReportError,
    },
  ] = useFetchData({
    query: "/reports/add",
    selectData: (data) => data,
  });

  useEffect(() => {
    if (uploadingReportError) {
      messageApi.error(uploadingReportError.message);
      clearUploadingReportError?.();
    }
  }, [uploadingReportError, messageApi]);

  useEffect(() => {
    if (uploadingReportData?.success && !isLoadingReport) {
      messageApi.success(PHRASES_DICTIONARY.SUCCESS.report_upload)
      setSelectedCheckbox([])
    }
  }, [isLoadingReport, messageApi]);

  useEffect(() => {
    setRulesDataTable([])
  }, [classNameFilterValues, rulesData]
  )
  const filterStructure = buildFilterStructure(activeFilters);

  useEffect(() => {
    setRulesDataTable(
      rulesData?.map((rule) => ({
        ruleName: rule.rule_name,
        text: rule.rule_text,
        id: rule._id,
        targetCharacteristics: rule.target_attrs.map((attr) => {
          return <Tag color="blue" key={attr} style={{ marginRight: "var(--spacing-xs)" }}>{attr}</Tag>;
        }),
      })))
  }, [rulesData]);

  return (
    <ContainerWrapper>
      <Filters
        appliedFilters={appliedFilters}
        setAppliedFilters={setAppliedFilters}
        currentAvailableFilters={availableRulesFilters}
        ignoredFilter={ignoredFilter}
        setIgnoredFilter={setIgnoredFilter}
        updateFilter={updateFilter}
        defaultOpenKeys={DEFAULT_OPEN_KEYS_RULES}
      />
      <StyledButtonContainer>
        <ActionButton
          text="Add New"
          className="primary-btn-color"
          icon={<Icon icon={LuClipboardPlus} />}
          iconPosition="end"
          onClick={() => navigate("add_new")}
        />
        <ActionButton
          text="GET"
          className="primary-btn-color"
          icon={<Icon icon={TbTableDown} />}
          iconPosition="end"
          onClick={() => {
            setSelectedCheckbox([])
            fetchRulesData({}, { sort: appliedRef.current, filters: filterStructure });
          }}
          loading={isLoadingRulesData}
        />
      </StyledButtonContainer>

      <Table
        className="primary-table"
        rowKey="id"
        showSorterTooltip={false}
        tableLayout="auto"
        columns={columns}
        dataSource={rulesDataTable}
        onChange={(pagination, filters, sorter) => {
          if (page == pagination.current) {
            const sort = onSorter(sorter);
            appliedRef.current = sort;
            fetchRulesData({}, { sort: sort, filters: filterStructure });
          } else {
            loadMore(pagination.current);
          }
        }}
        pagination={{
          current: page,
          pageSize: 15,
          total: totalRows,
          showSizeChanger: false,
          showQuickJumper: true,
        }}
        rowSelection={{
          type: "checkbox",
          selectedRowKeys: selectedCheckbox,
          onChange: setSelectedCheckbox,
        }}
      />
      <Row style={{gap: "var(--spacing-xs)"}}>
        <Dropdown 
        overlayStyle={{ zIndex: 900 }}
        menu={{
          items: ALL_BATCHES,
          onClick: (info) => setSelectedBatch(info.key),
          selectedKeys: [selectedBatch]
        }}
          trigger={["click"]}
        >
          <Button
            icon={<Icon icon={FaChevronDown} />}
            className="btn-color"
          >
            {selectedBatch}
          </Button>
        </Dropdown>
        <ActionButton
          className="primary-btn-color"
          text={`Check Rules (${selectedCheckbox?.length ?? 0})`}
          disabled={!selectedCheckbox?.length}
          styles={{ width: 150 }}
          onClick={() =>
            fetchUploadReport({}, { batch: selectedBatch, filters: filterStructure, rule_ids: selectedCheckbox })
          }
        />
      </Row>
    </ContainerWrapper>
  );
};

export default Rules;
